export const SNACKBAR_ALERT_DEFAULT_PROPS = {
    showSnackbar: true,
    autoHideDuration: 5000,
    message: '',
    severity: 'success' as 'success' | 'error'
};
export const TITLE = 'accessing Machines';
export const SUBJECT_ID_COPIED_TO_CLIPBOARD = 'Subject ID copied to clipboard';
export const CLIENT_ID_COPIED_TO_CLIPBOARD = 'Client ID copied to clipboard';
export const SEARCH_MACHINE = 'Search Machine (Min. 3 chars)';
export const DELETE = 'delete';
export const CLIENT_SECRET_TITLE = 'Client Secret';
export const BUTTON_CLOSE = 'Close';
export const ROTATE_CLIENT_SECRET_FAILURE = 'Error while rotating client secret';
export const ROTATE_CLIENT_SECRET_SUCCESS = 'Client secret rotated successfully';
export const ROTATE_SECRET_TITLE = 'Are you sure you want to rotate the client secret for ';
export const ROTATE_SECRET = 'Rotate Client Secret';
export const ADD_MACHINE = 'Add Machine';
export const GET_MACHINE_ERROR = 'Error while fetching machines: {0}';